import React, { useState } from "react";
import { DgaIcon } from "platformscode-new-react";
import "./footer.css";
const AmaanahLogo = "/assets2/logos/hmm-logo-01-compressed.webp";
const AILogo = "/assets2/imges/AI logo.png";
const Vision2030Logo = "/assets2/logos/vision2030.svg";

const footerBg = "/assets2/imges/footer-backeground.svg";
const FoundingDayLogo = "/assets2/logos/Saudi Founding Day Logo.svg";

const FooterElement = ({
  footerData, toggleViewMode,
  groupLinks: sectionsData,
  socialMediaLinks: socialData,
  copyright: copyrightProp,
  lastUpdate: lastUpdateProp,
  basicLinks: basicData,
  extraLinks: extraData,
  bottomImages: imagesData,
  socialMediaTitle: socialTitle,
  accessibilityTitle: accessTitle,
}) => {
  const [zoomLevel, setZoomLevel] = useState(0);

  const sections = sectionsData || [];
  const socialMedia = socialData || [];
  const copyrightText = copyrightProp || "جميع الحقوق محفوظة لأمانة العاصمة المقدسة © 2026";
  const updateText = lastUpdateProp || "تاريخ آخر تعديل: 02/02/2026 م بتوقيت السعودية";
  const basicLinksArray = basicData || [];
  const extraLinksArray = extraData || [];
  const bottomImagesArray = imagesData || [];
  const socialTitleText = socialTitle || "تواصل معنا";
  const accessTitleText = accessTitle || "أدوات الاتاحة والوصول";

  const zoomOut = () => {
    if (zoomLevel > -2) {
      const newZoomLevel = zoomLevel - 1;
      setZoomLevel(newZoomLevel);
      document.body.classList.remove("scale-n2", "scale-n1", "scale1", "scale2", "scale3");
      if (newZoomLevel === -2) document.body.classList.add("scale-n2");
      else if (newZoomLevel === -1) document.body.classList.add("scale-n1");
      else if (newZoomLevel === 1) document.body.classList.add("scale1");
      else if (newZoomLevel === 2) document.body.classList.add("scale2");
      else if (newZoomLevel === 3) document.body.classList.add("scale3");
    }
  };

  const zoomIn = () => {
    if (zoomLevel < 3) {
      const newZoomLevel = zoomLevel + 1;
      setZoomLevel(newZoomLevel);
      document.body.classList.remove("scale-n2", "scale-n1", "scale1", "scale2", "scale3");
      if (newZoomLevel === -1) document.body.classList.add("scale-n1");
      else if (newZoomLevel === 1) document.body.classList.add("scale1");
      else if (newZoomLevel === 2) document.body.classList.add("scale2");
      else if (newZoomLevel === 3) document.body.classList.add("scale3");
    }
  };

  const renderDynamicLinks = (links, className = "footer-link") => {
    if (!links || links.length === 0) return null;
    return (
      <ul role="list" className="footer-contnet">
        {links.map((link, index) => (
          <li key={index} className="flex gap-[4px] items-center">
            <a
              className={className}
              href={link.url || link.target || "#"}
              target={link.external ? "_blank" : "_self"}
              rel={link.external ? "noopener noreferrer" : undefined}
              aria-label={link.external ? `${link.name || link.title} - يفتح في نافذة جديدة` : undefined}
            >
              {link.name || link.title}
            </a>
            {link.external && (
              <DgaIcon
                aria-hidden="true"
                color="#fff"
                icon="link-square-02"
                size={14}
                type=""
                variant="stroke"
              />
            )}
          </li>
        ))}
      </ul>
    );
  };

  const renderSocialLink = (social, index) => (
    <li key={index}>
      <a
        href={social.target || "#"}
        className="border-green"
        aria-label={`${social.title} - يفتح في نافذة جديدة`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {social.icon ? (
          <DgaIcon
            aria-hidden="true"
            color={social.icon.color || "#fff"}
            icon={social.icon.name}
            size={24}
            type={social.icon.type || ""}
            variant={social.icon.variant || "stroke"}
          />
        ) : (
          <i
            aria-hidden="true"
            className={`hgi-stroke hgi-${social.icon?.name || "link"}`}
            style={{ color: "#fff", fontSize: "24px" }}
          />
        )}
      </a>
    </li>
  );

  const renderSocialIcons = () => {
    if (socialMedia && socialMedia.length > 0) {
      return (
        <ul className="footer-social-list" aria-label={socialTitleText}>
          {socialMedia.map((social, index) => renderSocialLink(social, index))}
        </ul>
      );
    }

    const allSocialIcons = [
      { icon: { name: "instagram",  color: "#fff", variant: "stroke" }, title: "انستغرام", target: "https://www.instagram.com/MakkahMunicipality/" },
      { icon: { name: "snapchat",   color: "#fff", variant: "stroke" }, title: "سناب شات", target: "https://www.snapchat.com/add/holymakkah" },
      { icon: { name: "linkedin-01",color: "#fff", variant: "stroke" }, title: "لينكد إن", target: "https://www.linkedin.com/company/makkahmunicipality/" },
      { icon: { name: "youtube",    color: "#fff", variant: "stroke" }, title: "يوتيوب",   target: "https://www.youtube.com/user/MakkahMunicipality" },
      { icon: { name: "whatsapp",   color: "#fff", variant: "stroke" }, title: "واتساب",  target: "http://wa.me/966539400940" },
      { icon: { name: "new-twitter",color: "#fff", variant: "stroke" }, title: "تويتر",   target: "https://twitter.com/holymakkah" },
      { icon: { name: "tiktok",     color: "#fff", variant: "stroke" }, title: "تيك توك", target: "https://www.tiktok.com/@makkahmunicipality" },
    ];

    return (
      <ul className="footer-social-list" aria-label={socialTitleText}>
        {allSocialIcons.map((social, index) => renderSocialLink(social, index))}
      </ul>
    );
  };

  const renderAccessibilityIcons = () => {
    const fixedAccessibilityIcons = [
      { icon: { name: "view", type: "rounded", color: "#fff", variant: "stroke" }, title: "تغيير وضع العرض", action: "view" },
      { icon: { name: "zoom-in-area", type: "rounded", color: "#fff", variant: "stroke" }, title: "تكبير النص", action: "zoom-in" },
      { icon: { name: "zoom-out-area", type: "rounded", color: "#fff", variant: "stroke" }, title: "تصغير النص", action: "zoom-out" },
    ];

    const handleAction = (action) => {
      switch (action) {
        case "view": toggleViewMode?.(); break;
        case "zoom-in": zoomIn(); break;
        case "zoom-out": zoomOut(); break;
      }
    };

    return (
      <div className="flex justify-start gap-[8px]" role="group" aria-label={accessTitleText}>
        {fixedAccessibilityIcons.map((access, index) => (
          <button
            key={index}
            type="button"
            className="border-green"
            aria-label={access.title}
            onClick={() => handleAction(access.action)}
          >
            <DgaIcon
              aria-hidden="true"
              color={access.icon.color}
              icon={access.icon.name}
              size={24}
              type={access.icon.type}
              variant={access.icon.variant}
            />
          </button>
        ))}
      </div>
    );
  };

  return (
    <footer
      aria-label="تذييل الصفحة"
      className="footer-bg"

    >
      <div className="c-ontent">
        <div className="cw-full">
          <div className="footer-container">

            {/* Main nav columns */}
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 lg:gap-[24px] pt-4 pb-10">

              <div className="footer-item">
                <div className="line-title">
                  <h2 className="footer-title">{sections[0]?.title || "ملخص"}</h2>
                </div>
                {sections[0]?.links ? renderDynamicLinks(sections[0].links) : (
                  <nav aria-label="ملخص" className="footer-contnet">
                    <ul role="list">
                      <li><a className="footer-link" href="#">حول أمانة العاصمة المقدسة</a></li>
                      <li><a className="footer-link" href="#">الأخبار والأحداث</a></li>
                      <li><a className="footer-link" href="#">خدمات الأفراد</a></li>
                      <li><a className="footer-link" href="#">مشاريع الأمانة</a></li>
                      <li><a className="footer-link" href="#">إحصائيات اتفاقية مستوى الخدمة</a></li>
                    </ul>
                  </nav>
                )}
              </div>

              <div className="footer-item">
                <div className="line-title">
                  <h2 className="footer-title">{sections[1]?.title || "روابط مهمة"}</h2>
                </div>
                {sections[1]?.links ? renderDynamicLinks(sections[1].links) : (
                  <nav aria-label="روابط مهمة" className="footer-contnet">
                    <ul role="list">
                      <li><a className="footer-link" href="https://my.gov.sa/ar" target="_blank" rel="noopener noreferrer" aria-label="المنصة الوطنية الموحدة - يفتح في نافذة جديدة">المنصة الوطنية الموحدة</a></li>
                      <li><a className="footer-link" href="https://open.data.gov.sa/ar/home" target="_blank" rel="noopener noreferrer" aria-label="منصة البيانات المفتوحة - يفتح في نافذة جديدة">منصة البيانات المفتوحة</a></li>
                      <li><a className="footer-link" href="https://sdaia.gov.sa/ar/SDAIA/SdaiaStrategies/Pages/NationalStrategyForDataAndAI.aspx" target="_blank" rel="noopener noreferrer" aria-label="الاستراتيجية الوطنية للبيانات والذكاء الاصطناعي - يفتح في نافذة جديدة">الاستراتيجية الوطنية للبيانات والذكاء الاصطناعي</a></li>
                      <li><a className="footer-link" href="https://eparticipation.my.gov.sa/" target="_blank" rel="noopener noreferrer" aria-label="منصة المشاركة الإلكترونية - يفتح في نافذة جديدة">منصة المشاركة الإلكترونية</a></li>
                    </ul>
                  </nav>
                )}
              </div>

              <div className="footer-item">
                <div className="line-title">
                  <h2 className="footer-title">{sections[2]?.title || "المساعدة والدعم"}</h2>
                </div>
                {sections[2]?.links ? renderDynamicLinks(sections[2].links) : (
                  <nav aria-label="المساعدة والدعم" className="footer-contnet">
                    <ul role="list">
                      <li><a className="footer-link" href="tel:0125739555" aria-label="اتصل بنا على الرقم 0125739555">رقم الهاتف: 01 257 39555</a></li>
                      <li><a className="footer-link" href="/contact">تواصل معنا</a></li>
                      <li><a className="footer-link" href="https://my.gov.sa/ar/content/report-corruption" target="_blank" rel="noopener noreferrer" aria-label="الإبلاغ عن حالة الفساد - يفتح في نافذة جديدة">الإبلاغ عن حالة الفساد</a></li>
                    </ul>
                  </nav>
                )}
              
              </div>

              <div className="footer-item">
                <div className="gap-[32px] grid">
                  <div>
                    <div className="line-title">
                      <h2 className="footer-title">{socialTitleText}</h2>
                    </div>
                    <div className="footer-contnet">{renderSocialIcons()}</div>
                  </div>
                  <div>
                    <div className="line-title">
                      <h2 className="footer-title">{accessTitleText}</h2>
                    </div>
                    <div className="footer-contnet">{renderAccessibilityIcons()}</div>
                  </div>
                </div>
              </div>

            </div>

            {/* Bottom bar */}
            <div className="grid grid-cols-1 md:grid-cols-[2fr_2fr] py-4 gap-[24px] ">
              <div className="gap-[24px] grid md:text-start text-start">
                <nav aria-label="روابط ثانوية">
                  <ul role="list" className="gap-[16px] flex justify-start">
                    {basicLinksArray && basicLinksArray.length > 0 ? (
                      basicLinksArray.map((link, index) => (
                        <li key={index} className="flex gap-[4px] items-center">
                          <a
                            className="footer-link !underline"
                            href={link.url || link.target || "#"}
                            target={link.external ? "_blank" : "_self"}
                            rel={link.external ? "noopener noreferrer" : undefined}
                            aria-label={link.external ? `${link.name || link.title} - يفتح في نافذة جديدة` : undefined}
                          >
                            {link.name || link.title}
                          </a>
                          {link.external && (
                            <DgaIcon
                              aria-hidden="true"
                              color="#fff"
                              icon="link-square-02"
                              size={14}
                              type=""
                              variant="stroke"
                            />
                          )}
                        </li>
                      ))
                    ) : (
                      <>
                          <li><a href="#" className="footer-link !underline">خريطة الموقع</a></li>
                          <li><a href="#" className="footer-link !underline">الخصوصية</a></li>
                          <li><a href="#" className="footer-link !underline">شروط الاستخدام</a></li>
                         
                      </>
                    )}

                    <li><a className="footer-link !underline" href="/faq">الأسئلة الشائعة</a></li>
                  </ul>
                </nav>

                <div className="gap-[12px] grid justify-start">
                  <p className="text-[#fff] !text-[14px] font-bold ">{copyrightText}</p>
                  <p className="text-[#fff] !text-[14px]">{extraLinksArray[0]?.name || "تم تطويره وصيانته بواسطة وكالة التحول الرقمي"}</p>
                  <p className="text-[#fff]  !text-[14px]">{extraLinksArray[1]?.name || updateText}</p>
                </div>
              </div>

              <div className="flex flex-col md:flex-row items-center justify-end gap-[16px]">
                {bottomImagesArray && bottomImagesArray.length > 0 ? (
                  bottomImagesArray.map((image, index) => {
                    const raw = image && (image.startsWith("http") || image.startsWith("/"))
                      ? image
                      : `https://hmm.gov.sa/${image}`;
                    const src = raw.includes('hmm.gov.sa') && raw.includes('logos')
                      ? '/assets2/logos/hmm-logo-01-compressed.webp'
                      : raw;
                    return (
                       <div className="flex flex-row md:flex-row items-center !gap-[16px] jusify-center">
                    <a href="/" aria-label="الصفحة الرئيسية">
                      <img
                        key={index}
                        style={{ height: "30px", width: "auto" }}
                        alt={`شعار ${index + 1}`}
                        src={src}
                        loading="lazy"
                        decoding="async"
                        onError={(e) => { e.currentTarget.style.display = "none"; }}
                      />
                    </a>
                    <a
                      href="https://sdaia.gov.sa/ar/MediaCenter/Pages/ai-year.aspx"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="الموقع الإلكتروني لعام الذكاء الاصطناعي - يفتح في نافذة جديدة"
                    >
                      <img style={{ height: "40px", width: "auto" }} alt="شعار عام الذكاء الاصطناعي" src={AILogo} loading="lazy" decoding="async" />
                    </a>
                    <a
                      href="https://www.vision2030.gov.sa/ar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="الموقع الإلكتروني لرؤية 2030 - يفتح في نافذة جديدة"
                    >
                      <img style={{ height: "40px", width: "auto" }} alt="شعار رؤية 2030" src={Vision2030Logo} loading="lazy" decoding="async" />
                    </a>
                  </div>
                    );

                  })
                ) : (
                  <div className="flex flex-col md:flex-row items-center gap-[16px]">
                    <a href="/" aria-label="الصفحة الرئيسية">
                      <img style={{ height: "30px", width: "auto" }} alt="شعار أمانة العاصمة المقدسة" src={AmaanahLogo} loading="lazy" decoding="async" />
                    </a>
                    <a
                      href="https://sdaia.gov.sa/ar/MediaCenter/Pages/ai-year.aspx"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="الموقع الإلكتروني لعام الذكاء الاصطناعي - يفتح في نافذة جديدة"
                    >
                      <img style={{ height: "40px", width: "auto" }} alt="شعار عام الذكاء الاصطناعي" src={AILogo} loading="lazy" decoding="async" />
                    </a>
                    <a
                      href="https://www.vision2030.gov.sa/ar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="الموقع الإلكتروني لرؤية 2030 - يفتح في نافذة جديدة"
                    >
                      <img style={{ height: "40px", width: "auto" }} alt="شعار رؤية 2030" src={Vision2030Logo} loading="lazy" decoding="async" />
                    </a>
                  </div>
                )}
              </div>
            </div>

          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterElement;
